import styled from 'styled-components';
import CustomReactTable from 'Common/Components/Contextualization/CustomReactTable/styled';
import colors from 'Styles/colors';

export const KbTableContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  scrollbar-gutter: stable;
`;
KbTableContainer.displayName = 'KbTableContainer';

export const KbCustomReactTable = styled(CustomReactTable)`
  overflow: visible;
  min-width: 100%;
  width: max-content;

  .rt-table,
  .rt-thead,
  .rt-tbody {
    min-width: 100%;
    width: max-content;
    overflow: visible;
  }

  .rt-th,
  .rt-td {
    flex: 0 0 auto !important;
  }
`;
KbCustomReactTable.displayName = 'KbCustomReactTable';

export const Col = styled.div`
  font-size: 12.5px;
  font-weight: 300;
  color: ${({ theme }) => theme.text.tableVulnName};
  pointer-events: none;
`;

export const ColKbName = styled(Col)`
  font-size: 14.5px;
  font-weight: 400;
  color: ${colors.dark5} !important;
  z-index: 10;
`;
ColKbName.displayName = 'ColKbName';

export const ColKbDescription = styled(Col)`
`;
ColKbDescription.displayName = 'ColKbDescription';

export const ColKbReferences = styled(Col)`
`;
ColKbReferences.displayName = 'ColKbReferences';

export const ColKbResolution = styled(Col)`
`;
ColKbResolution.displayName = 'ColKbResolution';

export const ColKbSeverity = styled(Col)`
`;
ColKbSeverity.displayName = 'ColKbSeverity';

export const ColKbPolicyViolations = styled(Col)`
`;
ColKbPolicyViolations.displayName = 'ColKbPolicyViolations';

export const ColKbCreator = styled(Col)`
`;
ColKbCreator.displayName = 'ColKbCreator';

export const ColKbCreatedDate = styled(Col)`
`;
ColKbCreatedDate.displayName = 'ColKbCreatedDate';
